<template>
  <main class="[ flow ] [ gap-b-3 pad-b-start-3 ]">
    <h1>Not found</h1>
  </main>
</template>
